import { Box, Typography, IconButton } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import Logo from "../../Assets/Logo6D.png";
import CertificateImage from "../../Assets/CertificateImg.png";
import CustomButton from "../Button/CustomButton";
import SignatureImage from "../../Assets/signature.png";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Barcode from "react-barcode";
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../Redux/UserSlice";
import { cookies } from "../../Controller/Common";
import { GetPDFCertificate } from "../../Api";

interface modalProps {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  certificate: any;
}
const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const monthShortNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthShortNames[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};
const CertificateModal: React.FC<modalProps> = ({ setOpen, certificate }) => {
  const canvasRef = React.useRef<HTMLCanvasElement>(null);
  const userName =
    useSelector((state: RootState) => state.user.userName) ??
    cookies.get("FirstName");
  React.useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas?.getContext("2d");

    if (canvas && context) {
      const dpi = 80;
      const widthInches = 29.7 * 0.393701;
      const heightInches = 21 * 0.393701;
      canvas.width = widthInches * dpi;
      canvas.height = heightInches * dpi;
      const img = new Image();
      img.src = CertificateImage;
      img.onload = () => {
        context.drawImage(img, 0, 0, canvas.width, canvas.height);

        const logo = new Image();
        logo.src = Logo;
        logo.onload = async () => {
          const desiredWidth = 130;
          const aspectRatio = logo.width / logo.height;
          const desiredHeight = desiredWidth / aspectRatio;
          const logoYPosition = 190;
          context.drawImage(
            logo,
            canvas.width / 2 - desiredWidth / 2,
            logoYPosition,
            desiredWidth,
            desiredHeight
          );

          let textYPosition = logoYPosition + desiredHeight + 30;
          context.font = "600 32px Poppins";
          context.fillStyle = "#7c7b63";
          context.textAlign = "center";
          context.fillText(
            "CERTIFICATE OF COMPLETION",
            canvas.width / 2,
            textYPosition
          );

          textYPosition += 30;
          context.font = "400 16px Poppins";
          context.fillStyle = "#7c7b63";
          context.fillText(
            "This is presented to",
            canvas.width / 2,
            textYPosition
          );

          textYPosition += 50;
          context.font = "500 38px Teko";
          context.fillStyle = "#ef1c36";
          context.fillText(
            userName.toUpperCase(),
            canvas.width / 2,
            textYPosition
          );

          textYPosition += 40;
          context.font = "400 14px Poppins";
          context.fillStyle = "#7c7b63";
          context.fillText(
            "for the successful completion of",
            canvas.width / 2,
            textYPosition
          );

          textYPosition += 30;
          context.font = "500 16px Poppins";
          context.fillStyle = "#ef1c36";
          context.fillText(certificate.TITLE.toUpperCase(), canvas.width / 2, textYPosition);

          textYPosition += 30;
          const thirdPart = "on";
          const firstPart = `${formatDate(
            certificate.updatedAt || new Date().toISOString()
          )}`;
          const secondPart = "in 6D Platform.";
          context.font = "400 14px Poppins";
          const thirdPartWidth = context.measureText(thirdPart).width;
          context.font = "500 16px Poppins";
          const firstPartWidth = context.measureText(firstPart).width;
          context.font = "400 14px Poppins";
          const secondPartWidth = context.measureText(secondPart).width;
          const totalWidth = thirdPartWidth + firstPartWidth + secondPartWidth;
          const startX = (canvas.width - totalWidth) / 2;
          context.font = "400 14px Poppins";
          context.fillStyle = "#7c7b63";
          context.fillText(thirdPart, startX, textYPosition);
          context.font = "500 16px Poppins";
          context.fillStyle = "#ef1c36";
          context.fillText(
            firstPart,
            startX + thirdPartWidth + 45,
            textYPosition
          );
          context.font = "400 14px Poppins";
          context.fillStyle = "#7c7b63";
          context.fillText(
            secondPart,
            startX + thirdPartWidth + firstPartWidth + 55,
            textYPosition
          );

          const signature = new Image();
          signature.src = SignatureImage;

          await new Promise((resolve) => {
            signature.onload = resolve;
          });
          const targetWidth = 120;
          const targetHeight = 90;
          const signatureX = 40;
          const signatureY = 490;
          context.imageSmoothingEnabled = true;
          context.imageSmoothingQuality = "high";
          context.drawImage(
            signature,
            signatureX,
            signatureY,
            targetWidth,
            targetHeight
          );
          context.font = "400 14px Poppins";
          context.fillStyle = "#7c7b63";
          context.textAlign = "left";
          context.fillText(
            "Managing Director",
            signatureX + 16,
            signatureY + targetHeight + 10
          );

          textYPosition += 120;
          context.font = "400 12px Poppins";
          context.fillStyle = "#7c7b63";
          context.textAlign = "center";
          context.fillText("", canvas.width / 2, textYPosition);
          const barcodeContainer = document.createElement("div");
          document.body.appendChild(barcodeContainer);

          ReactDOM.render(
            <Barcode
              value={certificate.UCID}
              width={1.5}
              height={50}
              fontSize={0}
              displayValue={false}
              background="transparent"
            />,
            barcodeContainer,
            () => {
              const svgElement = barcodeContainer.querySelector("svg");
              if (svgElement) {
                const svgData = new XMLSerializer().serializeToString(
                  svgElement
                );
                const img = new Image();
                img.src = "data:image/svg+xml;base64," + btoa(svgData);
                img.onload = () => {
                  const barcodeX = canvas.width - 210;
                  const barcodeY = 430;
                  const barcodeWidth = 180;
                  const barcodeHeight = 50;
                  context.drawImage(
                    img,
                    barcodeX,
                    barcodeY + 110,
                    barcodeWidth,
                    barcodeHeight
                  );
                  document.body.removeChild(barcodeContainer);
                };
              }
            }
          );
        };
      };
    }
  }, [certificate]);

  const downloadCertificate = async (
    userName: string,
    courseName: string,
    date: string,
    certificateId: number
  ) => {
    await GetPDFCertificate(userName, courseName, date, certificateId);
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#eff4f7",
        borderRadius: "10px",
        padding: "48px",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <IconButton
        onClick={handleClose}
        sx={{ position: "absolute", top: 6, right: 6, fontSize: "24px" }}
      >
        <CloseIcon />
      </IconButton>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#FFFFFf",
          borderRadius: "10px",
          padding: "20px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "16px",
            color: "#3F3F40",
            p: "20px",
          }}
        >
          {certificate.TITLE}
        </Typography>
        <Box
          sx={{
            backgroundColor: "#cac7c7",
            height: "0.5px",
            width: "600px",
            marginBottom: "10px",
          }}
        />
        <div
          style={{
            maxWidth: "100%",
            margin: "0 auto",
            textAlign: "center",
            padding: "20px 0px 20px 0px",
          }}
        >
          <canvas
            ref={canvasRef}
            style={{
              width: "100%",
              maxWidth: "500px",
              height: "auto",
              aspectRatio: "700 / 500",
              borderRadius: "10px",
            }}
          />
        </div>
        <Box
          sx={{
            backgroundColor: "#646262",
            height: "0.3px",
            width: "600px",
            marginTop: "10px",
          }}
        />
        <Box sx={{ marginTop: "10px" }}>
          <CustomButton
            name="Download Certificate"
            variant="primary"
            startIcon={<FileDownloadIcon />}
            onClick={() =>
              downloadCertificate(
                userName,
                certificate.TITLE,
                certificate.updatedAt,
                certificate.UCID
              )
            }
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CertificateModal;
